<template>
  <div class="question-select">
    <!-- edit/add button -->
    <b-btn size="sm" variant="info" @click="showModal()">
      {{ buttonLabel }}
    </b-btn>

    <b-modal
      ref="selectQuestionModal"
      size="lg"
      class="text-left"
      :hide-footer="true"
    >
      <template slot="modal-header">
        <h5 class="modal-title">
          Select Question
        </h5>
        <div class="pull-right">
          <b-btn
            variant="default"
            @click="$refs.selectQuestionModal.hide(true)"
          >
            Cancel
          </b-btn>
          <b-btn variant="info" @click="addQuestion">
            Add Question
          </b-btn>
        </div>
      </template>
      <model-select
        :options="questionOptions"
        v-model="selectedQuestionOption"
        placeholder="Type part of question prompt..."
      >
      </model-select>
    </b-modal>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue';
import maxBy from 'lodash/maxBy';
import Api from '@/providers/Api.js';
import { ModelSelect } from 'vue-search-select';

export default Vue.extend({
  name: 'questionFinder',
  components: {
    ModelSelect,
  },
  props: {
    section: Object,
    questionnaire: Object,
    buttonLabel: String,
  },
  data() {
    return {
      questions: [],
      selectedQuestionOption: { value: '', text: '' },
    };
  },
  computed: {
    questionOptions: function () {
      return this.questions.map((qs) => ({
        value: qs,
        text: `Q${qs.id}: ${qs.prompt}`,
      }));
    },
    selectedQuestion: function () {
      return this.selectedQuestionOption &&
        this.selectedQuestionOption.value !== ''
        ? this.selectedQuestionOption.value
        : null;
    },
  },
  methods: {
    showModal() {
      this.$refs.selectQuestionModal.show();
    },
    addQuestion: async function() {
      if (!this.selectedQuestion) return;
      const qid = this.selectedQuestion.id;
      if (
        this.section.questionSections.some(
          ({ question_id }) => parseInt(question_id) === parseInt(qid)
        )
      ) {
        this.$toasted.error('This question already added to the section', {
          duration: 3000,
        });
        return;
      }
      let maxOrder = 0;
      if (this.section.questionSections.length) {
        maxOrder = maxBy(this.section.questionSections, (qs) => qs.order).order;
      }
      const question = await Api.getQuestion(qid);
      this.section.questionSections.push({
        section_id: this.section.id,
        question_id: qid,
        order: maxOrder + 1,
        is_default_on_results: 0,
        is_available_on_results: 0,
        is_on_dashboard: 0,
        dashboard_display_order: 0,
        question: question,
      });
      this.query = '';
      this.$refs.selectQuestionModal.hide();
    },
  },
  created() {
    Api.getAllQuestions(this).then((qs) => {
      this.questions = qs;
    });
  },
});
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
@import '../../node_modules/vue-search-select/dist/VueSearchSelect.css';
@import '../../sass/variables_mixins.scss';
.ui.fluid.dropdown {
  .menu.item {
    -webkit-font-smoothing: antialiased;
    pointer-events: auto;
    -webkit-box-direction: normal;
    color: #495057;
    box-sizing: border-box;
    line-height: 1.5;
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
      'Liberation Mono', 'Courier New', monospace;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 16px !important;
    font-weight: 400;
    text-align: inherit;
  }
}
.ui.dropdown {
  .menu > .item,
  .text {
    -webkit-font-smoothing: antialiased;
    pointer-events: auto;
    -webkit-box-direction: normal;
    color: #495057;
    box-sizing: border-box;
    line-height: 1.5;
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
      'Liberation Mono', 'Courier New', monospace;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    text-align: inherit;
  }
  .menu > .item.selected {
    color: $white;
    background-color: $light-blue;
    border-color: $light-blue;
    margin-top: -1px;
    border-top-width: 1px;
  }
}
.ui.search.dropdown .menu {
  max-height: 25rem !important;
}
</style>
